import { SubjectType, useAbility } from '@efexteam/permission-manager';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { USER_ACTIONS } from '../constants/userActions';
import UserActionsStyles from './UserActions.style';

const UserActions = () => {
  const { can } = useAbility();
  const { t } = useTranslation();

  return (
    <Box className={UserActionsStyles.wrapper}>
      {USER_ACTIONS.map((action) => (
        <div className={UserActionsStyles.actionElement} key={action.label}>
          {can(action.actions[0], action.actions[1] as SubjectType) ? (
            <CheckIcon className={UserActionsStyles.checkIcon} />
          ) : (
            <ClearIcon className={UserActionsStyles.clearIcon} />
          )}
          <Typography component="p" variant="caption">
            {t(
              can(action.actions[0], action.actions[1] as SubjectType)
                ? 'editMmbRoleCan'
                : 'editMmbRoleCannot'
            )}{' '}
            {t(action.label, {
              roles:
                action.label === 'editMmbEditTeamMembers'
                  ? `${t('memberOWNER')} ${t(`andConnector`)} ${t(
                      'memberADMIN'
                    )}`
                  : undefined,
            })}
          </Typography>
        </div>
      ))}
    </Box>
  );
};

export default UserActions;
